<mat-tab-group [(selectedIndex)]="selectedMatTabIndex" (selectedTabChange)="onSelectedMatTabChange($event)">
	<mat-tab label="Drill & Blast Costs Chart View">
		<div class="header-padding">
			<div class="header-container">
				<div class="report-info">
					<h2 class="report-title">Drill & Blast costs</h2>
					<p class="report-subtitle">
						<span class="subtitle-span">Drill & Blast Costs Chart View</span> - {{'visualizes the Tons per hour, Explosives, Total Drill & Blast, Secondary ' }}<span class="laptop-br"><br></span>
						{{ 'breakage, Crusher power consumption costs' }}
					</p>
				</div>
				<div class="export-btn">
					<button mat-raised-button color="primary" class="export-pdf-btn" loadingDrillAndBlastCosts (click)="pdfDownload()"><mat-icon
						class="svg-icon" svgIcon="pdfIcon"></mat-icon>Export As PDF</button>
				</div>
				
			</div>
		</div>
		<app-dashboard-chart-group [chartOptions]="chartOptions" [Highcharts]="Highcharts"
			(chartInstance)="onChartInstance($event.chart, $event.index)">
		</app-dashboard-chart-group>
	</mat-tab>

	<mat-tab label="Drill & Blast Costs Table View">
		<div class="header-padding">
			<div class="header-container">
				<div class="report-info">
					<h2 class="report-title">Drill & Blast costs</h2>
					<p class="report-subtitle">
						<span class="subtitle-span">Drill & Blast Costs Table View</span> - visualizes the drill & blast costs incurred in tabular form
					</p>
				</div>
				<div class="export-btn">
					<button mat-raised-button color="primary" class="export-pdf-btn custom-btn" (click)="initiateDrillAndBlastCosts()"><mat-icon svgIcon="addIcon" class="svg-icon"></mat-icon>Drill & Blast Cost</button>
					<button *ngIf="isNewRow" mat-raised-button color="primary" class="export-pdf-btn" (click)="addDrillAndBlastCosts()">Submit</button>
				</div>
			</div>
		</div>

		<div class="excel-style-container">
			<div class="table-content">
				<table class="data mat-elevation-z1 excel-table" mat-table [dataSource]="dataSource">
					<ng-container matColumnDef="datasetName">
						<th mat-header-cell *matHeaderCellDef>Project</th>
						<td mat-cell *matCellDef="let element">
							<ng-container *ngIf="!element.id; else displayColumn">
								<mat-select (selectionChange)="onDatasetSelect($event)" class="select-project">
									<mat-option *ngFor="let dataset of siteDatasetLists" [value]="dataset">{{dataset.name}}</mat-option>
								</mat-select>
							</ng-container>
	
							<ng-template #displayColumn>
								<span class="select-project">{{element.datasetName}}</span>
							</ng-template>
						</td>
					</ng-container>
	
					<ng-container [matColumnDef]="col.key" *ngFor="let col of dataSourceSchema">
						<th mat-header-cell *matHeaderCellDef>
							{{col.label}}
						</th>
	
						<td mat-cell *matCellDef="let element">
							<input [type]="col.type" matInput [title]="element[col.key]" [(ngModel)]="element[col.key]" readonly="true" (click)="onFieldInputClick($event, col)" (ngModelChange)="onFieldInputChange(element, col.key, $event)" />
						</td>
					</ng-container>
	
					<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
	
					<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
				</table>
			</div>

			<mat-paginator
				pageSize="30"
				[pageSizeOptions]="[30, 40]"
				hidePageSize="true"
			>
			</mat-paginator>
		</div>
	</mat-tab>
</mat-tab-group>

<div class="loading-container" *ngIf="loadingDrillAndBlastCosts">
	<mat-spinner></mat-spinner>
</div>